







import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import createjs from 'createjs-npm';
import Game from '@/servers/modules/game/index'; // server
import { Howl, Howler } from 'howler';
import { Base, App } from '../common/base';
import { config } from './config.js';

@Component({
  components: {
  },
})
export default class extends Vue {
    @Getter public getGameLoading: any;

    @Mutation public setDataLoading: any;

    @Mutation public setGameLoading: any;

    private app: any;

    private data: any = [
      // {content: 'x', id: 1},
      // {content: 'x', id: 1},
      // {content: 'x', id: 2},
      // {content: 'x', id: 2},
      // {content: 'x', id: 3},
      // {content: 'x', id: 3},
      // {content: 'x', id: 4},
      // {content: 'x', id: 4},
      // {content: 'x', id: 5},
      // {content: 'x', id: 5},
      // {content: 'x', id: 6},
      // {content: 'x', id: 6},
      // {content: 'x', id: 7},
      // {content: 'x', id: 7},
      // {content: 'x', id: 8},
      // {content: 'x', id: 8},
      // {content: 'x', id: 9},
      // {content: 'x', id: 9},
      // {content: 'x', id: 11},
      // {content: 'x', id: 11},
    ];

    // bg music
    private bgMusic: any;

    // 当前选中的下标
    private currentActiveIndex: any;

    // 当前选中的id
    private currentActiveId: any;

    // 第几次点击
    private clickTimes: number = 0;

    // 当前得分
    private scoreNumber: number = 0;

    // 当前错误次数
    private errNumber: number = 0;

    // 倒计时 3分钟
    private countdownTime: number = 3 * 60 * 1000;

    // 当前时间
    private currentCountDownTime: number = 3 * 60 * 1000;

    // 定时器
    private countdownTimer: any;

    // 连续做对题数
    private currencyRightNumber: number = 0;

    // 进度条设计稿宽度
    private progressWidth: number = 797;

    // gameStatistics
    private gameStatisticsId: any;

    private residueDegree: any;

    // 是否记录排行
    private playModel: any = 1;

    // 参数
    private para: any = {
      accuracyNum: '', // 正确数量
      courseId: window.LS.get('vteData').course.courseId, // 课程编号
      errorNum: '', // 错误数量
      firstLoad: 0, // 0-第一次加载，1-非第一次加载
      gameId: 4, // 游戏编号
      gameStatisticsId: '', // 游戏记录编号
      playModel: 1, // 0-不记录成绩，1-记录成绩,默认为1
      userId: window.LS.get('basicData').userID, // 学生编号
      sendScore: 1, // 不发送成绩
    }

    private created() {
      // this.setDataLoading(false);

    }

    private beforeDestroy() {
      createjs.Tween.removeAllTweens();
      this.bgMusic.stop();
      this.setDataLoading(true);
      this.setGameLoading(true);
    }

    private mounted() {
      const that: any = this;
      this.app = new createjs.Stage('root');
      // Howl
      const mousePointOver: any = new Howl({
        src: [require('@/assets/images/game/linker/sound1.mp3')],
      });
      this.bgMusic = new Howl({
        src: [require('@/assets/images/game/linker/mapBGM.mp3')],
        loop: true,
        // autoplay: true,
      });
      const soundscore: any = new Howl({
        src: [require('@/assets/images/game/linker/score.mp3')],
      });
      const sounderror: any = new Howl({
        src: [require('@/assets/images/game/linker/error.mp3')],
      });
      class CurrentGame extends Base {
        constructor(options: any) {
          super(options);
          // this.config = config
        }

            // 倒计时
            private countTime: any = createjs.Tween.get(that.progressshape);

            // 得分box
            private scoreContainer = new createjs.Container();

            // 失败box
            private errContainer = new createjs.Container();

            // 倒计时
            private progressshape: any;

            protected initStage(): void {
              // sprites 引入图片
              const bg = new createjs.Bitmap(App.loader.getResult('bg'));
              const back = new createjs.Bitmap(App.loader.getResult('back'));
              const title = new createjs.Bitmap(App.loader.getResult('title'));
              const btn = new createjs.Bitmap(App.loader.getResult('btn'));
              const tiger = new createjs.Bitmap(App.loader.getResult('tiger'));
              // game
              const plantl = new createjs.Bitmap(App.loader.getResult('plantl'));
              const plantr = new createjs.Bitmap(App.loader.getResult('plantr'));
              const border = new createjs.Bitmap(App.loader.getResult('border'));
              const goback = new createjs.Bitmap(App.loader.getResult('goback'));
              // level
              const score = new createjs.Bitmap(App.loader.getResult('score'));
              const wrong = new createjs.Bitmap(App.loader.getResult('wrong'));
              const sound = new createjs.Bitmap(App.loader.getResult('sound'));
              const nosound = new createjs.Bitmap(App.loader.getResult('nosound'));
              const logo = new createjs.Bitmap(App.loader.getResult('logo'));
              const right = new createjs.Bitmap(App.loader.getResult('right'));


              // 得分记录 失败次数记录
              // let scoreContainer = new createjs.Container();
              // let wrongContainer = new createjs.Container();
              const readyContainer = new createjs.Container();
              const gameContainer = new createjs.Container();
              // 初始化得分
              const scoreTimes = this.score(that.scoreNumber);
              // 初始化错误次数
              const errTimesMax = this.err(that.errNumber);
              this.errContainer.addChild(errTimesMax);
              this.scoreContainer.addChild(scoreTimes);
              this.scoreContainer.setTransform(1181, 54, 1, 1, 0, 0, 0, 0, 0);
              score.setTransform(1181, 54, 1, 1, 0, 0, 0, 0, 0);
              this.errContainer.setTransform(1476, 53, 1, 1, 0, 0, 0, 0, 0);
              wrong.setTransform(1476, 53, 1, 1, 0, 0, 0, 0, 0);
              // progress box
              const progressContainer = new createjs.Container();
              const progressbox = new createjs.Bitmap(App.loader.getResult('progressbox'));
              const progress = new createjs.Bitmap(App.loader.getResult('progress'));
              this.progressshape = new createjs.Shape();
              this.progressshape.graphics.drawRect(0, 0, progress.getBounds().width, progress.getBounds().height);
              progressContainer.addChild(progressbox, progress, this.progressshape);
              progressContainer.setTransform(252, 70, 1, 1, 0, 0, 0, 0, 0);
              progressbox.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
              progress.setTransform(14, 15, 1, 1, 0, 0, 0, 0, 0);
              this.progressshape.setTransform(14, 15, 1, 1, 0, 0, 0, 0, 0);
              // mask
              progress.mask = this.progressshape;
              // progress animation

              // 倒计时初始化

              // setTimeout(function(){
              //     countTime.setPaused(true);
              //     // speed+= 400;
              //     progressshape.x = - (797 / 10000) * 1000;
              //     countTime= createjs.Tween.get(progressshape)
              //     .to({x: -speed}, 10000, createjs.Ease.easeOut);

              // }, 3000);

              bg.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
              title.setTransform(607, 71, 1, 1, 0, 0, 0, 0, 0);
              tiger.setTransform(1471, 442, 1, 1, 0, 0, 0, 0, 0);
              btn.setTransform(868 + btn.getBounds().width / 2, 668 + btn.getBounds().height / 2, 1, 1, 0, 0, 0, btn.getBounds().width / 2, btn.getBounds().height / 2);
              readyContainer.addChild(bg, title, btn, tiger);
              // back.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
              // game
              plantl.setTransform(0, 861, 1, 1, 0, 0, 0, 0, 0);
              plantr.setTransform(1475, 861, 1, 1, 0, 0, 0, 0, 0);
              border.setTransform(234, 267, 1, 1, 0, 0, 0, 0, 0);
              goback.setTransform(47, 53, 1, 1, 0, 0, 0, 0, 0);
              sound.setTransform(1768, 53, 1, 1, 0, 0, 0, 0, 0);
              nosound.setTransform(1768, 53, 1, 1, 0, 0, 0, 0, 0);
              logo.setTransform(845, 982, 1, 1, 0, 0, 0, 0, 0);


              // let jia = new createjs.Bitmap(App.loader.getResult("jia"));
              // let jian = new createjs.Bitmap(App.loader.getResult("jian"));

              gameContainer.addChild(back, plantr, plantl);
              // init word
              const wordContainer = new createjs.Container();
              // setTimeout(()=> {
              //     gameContainer.removeChild(wordContainer)
              // },4000)
              wordContainer.setTransform(273, 306, 1, 1, 0, 0, 0, 0, 0);
              const initCountDownTime = (seconds: number) => {
                clearInterval(that.countdownTimer);
                this.countTime.setPaused(true);
                //     // speed+= 400;
                this.progressshape.x = -(797 / that.countdownTime) * seconds + 15;
                this.countTime = createjs.Tween.get(this.progressshape)
                  .to({ x: -that.progressWidth + 15 }, that.countdownTime, createjs.Ease.easeOut)
                  .call(() => {
                    // 清除定时器
                    // 时间结束后调接口
                    that.linkGameWordErr().then((res: any) => {
                      if (res.data.code == 0) {
                        that.residueDegree = res.data.data.residueDegree;
                        // 弹出结束
                        showMask();
                      }
                    });
                    // clearInterval(that.countdownTimer)
                  });
                that.countdownTimer = setInterval(() => {
                  that.currentCountDownTime -= 1000;
                  // console.log(that.currentCountDownTime);
                }, 1000);
              };
              const initWord = (firstLoad: boolean) => {
                that.firstLinkGameWord(that.para).then((res: any) => {
                  // 第一次加载完成
                  that.setDataLoading(false);
                  that.data = res.data.data && res.data.data.wordDetail;
                  that.gameStatisticsId = res.data.data.gameStatistics.gameStatisticsId;
                  that.residueDegree = res.data.data.residueDegree;
                  // 简单乱序
                  if (that.data) {
                    that.data.sort(() => (Math.random() > 0.5 ? -1 : 1));
                  }
                  // ---------------------
                  const wordShape = new createjs.Shape();
                  wordShape.graphics.beginFill('#FFEEC8').drawRect(-2, 0, 1368, 595);
                  wordContainer.addChild(wordShape);
                  // init width x y
                  let offsetX = 0;
                  const offsetY = 0;
                  const ruleX = 273;
                  const ruleY = 150;
                  // 选中的container
                  const checkedContainer = new createjs.Container();
                  checkedContainer.x = 273;
                  checkedContainer.y = 306;
                  // 测试用
                  // gameContainer.addChild(scorebg, five);
                  console.log(that.data);
                  that.data.map((item: any, index: number) => {
                    const wordItem = new createjs.Container();
                    // hover checked
                    const hoving = new createjs.Bitmap(App.loader.getResult('wordh'));
                    const right = new createjs.Bitmap(App.loader.getResult('right'));
                    wordItem.cursor = 'pointer';
                    const shape = new createjs.Shape();
                    shape.graphics.beginFill('#ffffff').drawRect(0, 0, 270, 147);
                    let text: any;
                    let textHover: any;
                    // 字符少于8个
                    function replaceStr(str: any) {
                      return str.replace(/(.{1})/g, '$1 ');
                    }
                    function CheckChinese(val: any) {
                      const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
                      return reg.test(val);
                    }
                    if (CheckChinese(item.content)) {
                      item.content = replaceStr(item.content);
                    }


                    if (item.content.length < 8) {
                      text = new createjs.Text(item.content, '36px PingFangSC-Regular', '#883F05');
                      textHover = new createjs.Text(item.content, '36px PingFangSC-Regular', '#3591FE');
                    } else if (item.content.length >= 8 && item.content.length < 16) {
                      // alert(2)
                      text = new createjs.Text(item.content, '34px PingFangSC-Regular', '#883F05');
                      textHover = new createjs.Text(item.content, '34px PingFangSC-Regular', '#3591FE');
                    } else if (item.content.length >= 16) {
                      text = new createjs.Text(item.content, '30px PingFangSC-Regular', '#883F05');
                      textHover = new createjs.Text(item.content, '30px PingFangSC-Regular', '#3591FE');
                    }

                    if (text.getBounds().width > 260) {
                      text.set({
                        textAlign: 'center',
                        textBaseline: 'middle',
                        x: 260 / 2,
                        y: 147 / 2 - text.getBounds().height / 2,
                        lineWidth: 260,
                      });
                      console.log(text.getBounds().height);

                      textHover.set({
                        textAlign: 'center',
                        textBaseline: 'middle',
                        x: 260 / 2,
                        y: 147 / 2 - textHover.getBounds().height / 2,
                        lineWidth: 260,
                      });
                    } else {
                      text.set({
                        textAlign: 'center',
                        textBaseline: 'middle',
                        x: 260 / 2,
                        y: 147 / 2,
                        lineWidth: 260,
                      });
                      textHover.set({
                        textAlign: 'center',
                        textBaseline: 'middle',
                        x: 260 / 2,
                        y: 147 / 2,
                        lineWidth: 260,
                      });
                    }


                    wordItem.addChild(shape, text);
                    wordItem.x = offsetX;
                    wordContainer.addChild(right, wordItem);
                    if (index < 5) {
                      wordItem.x = offsetX;
                      wordItem.y = 0;
                      right.x = offsetX;
                      right.y = 0;
                    } else if (index >= 5 && index < 10) {
                      wordItem.x = offsetX - 5 * ruleX;
                      wordItem.y = ruleY;
                      right.x = offsetX - 5 * ruleX;
                      right.y = ruleY;
                    } else if (index >= 10 && index < 15) {
                      wordItem.x = offsetX - 10 * ruleX;
                      wordItem.y = ruleY * 2;
                      right.x = offsetX - 10 * ruleX;
                      right.y = ruleY * 2;
                    } else if (index >= 15 && index < 20) {
                      wordItem.x = offsetX - 15 * ruleX;
                      wordItem.y = ruleY * 3;
                      right.x = offsetX - 15 * ruleX;
                      right.y = ruleY * 3;
                    }
                    offsetX += ruleX;
                    // 鼠标事件不穿透到子元素
                    wordItem.mouseChildren = false;
                    wordItem.on('mouseover', (e: any) => {
                      hoving.x = wordItem.x - 3;
                      hoving.y = wordItem.y - 3;
                      if (textHover.getBounds().height > 60) { // 换行了
                        // console.log(textHover.getBounds().height );
                        textHover.set({
                          textAlign: 'center',
                          textBaseline: 'middle',
                          x: wordItem.x + 260 / 2,
                          lineWidth: 260,
                          y: wordItem.y + (147 / 2 - textHover.getBounds().height / 2) + 18,
                        });
                      } else {
                        textHover.set({
                          textAlign: 'center',
                          textBaseline: 'middle',
                          x: wordItem.x + 260 / 2,
                          lineWidth: 260,
                          y: wordItem.y + 147 / 2,
                        });
                      }
                      // console.log(textHover.getBounds().height);


                      checkedContainer.addChild(hoving, textHover);
                      mousePointOver.play();
                    });
                    wordItem.on('mouseout', (e: any) => {
                      if (that.currentActiveIndex != index) {
                        checkedContainer.removeChild(hoving, textHover);
                      }

                      // mousePointOver.play();
                    });

                    wordItem.on('click', (e: any) => {
                      // 第一次点击
                      if (that.clickTimes == 0) {
                        // 当前点击下标
                        that.currentActiveIndex = index;
                        // 点击id
                        that.currentActiveId = item.id;
                        hoving.x = wordItem.x - 3;
                        hoving.y = wordItem.y - 3;
                        if (textHover.getBounds().height > 60) { // 换行了
                          textHover.set({
                            textAlign: 'center',
                            textBaseline: 'middle',
                            x: wordItem.x + 260 / 2,
                            lineWidth: 260,
                            y: wordItem.y + (147 / 2 - textHover.getBounds().height / 2) + 18,
                          });
                        } else {
                          textHover.set({
                            textAlign: 'center',
                            textBaseline: 'middle',
                            x: wordItem.x + 260 / 2,
                            lineWidth: 260,
                            y: wordItem.y + 147 / 2,
                          });
                        }
                        checkedContainer.addChild(hoving, textHover);
                        // 计数
                        that.clickTimes++;
                      } else if (that.clickTimes == 1) {
                        // 第二次点击 判断是否点击同一个块
                        // 同一个的话 重置
                        // 恢复状态
                        if (that.currentActiveIndex == index) {
                          gameContainer.removeChild(hoving, textHover);
                          that.clickTimes = 0;
                          that.currentActiveIndex = null;
                          that.currentActiveId = null;
                        } else {
                          // 第二次点击 不同的块
                          // 判断id是否一致 一致则得分 两个块消失
                          if (that.currentActiveId == item.id) {
                            // gameContainer.removeChild(checkedContainer);
                            checkedContainer.removeAllChildren();

                            wordContainer.getChildAt((index + 1) * 2).alpha = 0;
                            wordContainer.getChildAt((that.currentActiveIndex + 1) * 2).alpha = 0;
                            // wordContainer.getChildAt(index);
                            that.clickTimes = 0;
                            that.currentActiveIndex = null;
                            that.currentActiveId = null;
                            // 得分加1
                            soundscore.play();
                            // +1 动效
                            addScore(1);
                            setTimeout(() => {
                              this.scoreContainer.removeAllChildren();
                              const scoreTimes = this.score(that.scoreNumber);
                              this.scoreContainer.addChild(scoreTimes);
                            }, 1000);
                            that.scoreNumber++;
                            // 完成一组
                            if (that.scoreNumber % 10 == 0) {
                              // alert('end');
                              wordContainer.removeAllChildren();
                              that.para.firstLoad = 1;
                              that.para.gameStatisticsId = that.gameStatisticsId;
                              initWord(false);
                            }

                            // 连续做对5题，且不为4的整数倍 + 5秒
                            that.currencyRightNumber++;
                            if (that.currencyRightNumber == 5 && that.scoreNumber % 4 != 0) {
                              // alert(5)
                              // 进度条改变

                              that.currentCountDownTime += 5000;
                              initCountDownTime(that.currentCountDownTime > that.countdownTime ? 0 : that.countdownTime - that.currentCountDownTime);
                              // 动画展示
                              addTimeAn(5);
                              that.currencyRightNumber = 0;
                            }
                            // 连续做对5题，且为4的整数倍 + 15秒
                            if (that.currencyRightNumber == 5 && that.scoreNumber % 4 == 0) {
                              that.currentCountDownTime += 15000;
                              console.log(that.currentCountDownTime);
                              initCountDownTime(that.currentCountDownTime > that.countdownTime ? 0 : that.countdownTime - that.currentCountDownTime);

                              // 动画展示
                              addTimeAn(15);
                              that.currencyRightNumber = 0;
                            }
                          } else {
                            // 错误恢复状态
                            that.clickTimes = 0;
                            that.currentActiveIndex = null;
                            that.currentActiveId = null;
                            checkedContainer.removeAllChildren();

                            // 错误计数
                            sounderror.play();
                            that.errNumber++;
                            if (that.errNumber == 10) {
                              that.linkGameWordErr().then((res: any) => {
                                if (res.data.code == 0) {
                                  that.residueDegree = res.data.data.residueDegree;
                                  // 弹出结束
                                  showMask();
                                }
                              });
                            }

                            addScore(2);
                            setTimeout(() => {
                              this.errContainer.removeAllChildren();
                              const errTimesMax = this.err(that.errNumber);
                              this.errContainer.addChild(errTimesMax);
                            }, 1000);
                          }
                        }
                      }
                    });
                  });

                  gameContainer.addChild(checkedContainer);
                });
              };
              // mask
              const showMask = () => {
                clearInterval(that.countdownTimer);
                this.countTime.setPaused(true);
                that.currencyRightNumber = 0;
                that.currentCountDownTime = that.countdownTime;
                const maskContainer = new createjs.Container();

                const mask = this.initMask();
                const dialog = new createjs.Bitmap(App.loader.getResult('dialog'));
                maskContainer.setTransform(676, 319, 1, 1, 0, 0, 0, 0, 0);
                const onemore = new createjs.Bitmap(App.loader.getResult('onemore'));
                const onemorea = new createjs.Bitmap(App.loader.getResult('onemorea'));
                const selected = new createjs.Bitmap(require('@/assets/images/game/linker/selected.png'));
                const unselected = new createjs.Bitmap(require('@/assets/images/game/linker/uns.png'));
                onemore.setTransform(89, 310, 1, 1, 0, 0, 0, 0, 0);
                onemorea.setTransform(89, 310, 1, 1, 0, 0, 0, 0, 0);
                // 默认选中状态

                if (that.para.playModel == 1) {
                  unselected.alpha = 0;
                  selected.alpha = 1;
                } else {
                  unselected.alpha = 1;
                  selected.alpha = 0;
                }
                selected.cursor = 'pointer';
                unselected.cursor = 'pointer';
                // 123
                const text = new createjs.Text(`今天还可以玩${that.residueDegree}次`, '20px PingFangSC-Regular', '#FFC800');
                selected.on('click', (e: any) => {
                  // 不展示 不计入排行
                  that.para.playModel = 0;
                  selected.alpha = 0;
                  // text.alpha = 0;
                  unselected.alpha = 1;
                  // console.log(that.para);
                });
                unselected.on('click', (e: any) => {
                  // 展示 计入排行
                  that.para.playModel = 1;
                  selected.alpha = 1;
                  // text.alpha = 1;
                  unselected.alpha = 0;
                  // console.log(that.para);
                });
                onemore.cursor = 'pointer';
                onemorea.cursor = 'pointer';
                onemore.on('mousedown', (e: any) => {
                  // 再来一局
                  if (that.residueDegree == 0) {
                    that.$router.push(
                      {
                        path: '/vocabulary/afterschoolexpand?type=through',
                        // query: {
                        //     id: 4,
                        //     // gameId: scope.row.game.id
                        // }
                      },
                    );
                    return false;
                  }
                  // maskContainer.rem oveAllChildren();
                  maskContainer.removeChild(onemore);

                  // this.progressshape.x = 0;

                  // int progress
                  initCountDownTime(0);
                  // 重置
                  wordContainer.removeAllChildren();
                  that.para.firstLoad = 0;
                  that.para.sendScore = 1;
                  that.para.gameStatisticsId = '';
                  initWord(false);
                  that.app.stage.update();
                });
                onemore.on('pressup', (e: any) => {
                  //
                  // onemore.alpha = 0;
                  // 如果有游戏次数 重新开始
                  // 失败次数重置
                  that.errNumber = 0;
                  const errTimesMax = this.err(that.errNumber);
                  this.errContainer.addChild(errTimesMax);
                  // 得分重置
                  that.scoreNumber = 0;
                  const scoreTimes = this.score(that.scoreNumber);
                  this.scoreContainer.addChild(scoreTimes);
                  that.app.stage.removeChild(mask, maskContainer);
                  that.app.stage.update();
                });
                // one more 不玩了


                const goover = new createjs.Bitmap(App.loader.getResult('goover'));
                const goovera = new createjs.Bitmap(App.loader.getResult('goovera'));
                goover.setTransform(314, 310, 1, 1, 0, 0, 0, 0, 0);
                goovera.setTransform(314, 310, 1, 1, 0, 0, 0, 0, 0);
                selected.setTransform(122, 198, 1, 1, 0, 0, 0, 0, 0);
                unselected.setTransform(122, 198, 1, 1, 0, 0, 0, 0, 0);
                text.setTransform(215, 249, 1, 1, 0, 0, 0, 0, 0);
                goover.cursor = 'pointer';
                goovera.cursor = 'pointer';
                goover.on('mousedown', (e: any) => {
                  //
                  goover.alpha = 0;
                });
                goover.on('pressup', (e: any) => {
                  that.$router.push(
                    {
                      path: '/vocabulary/afterschoolexpand?type=through',
                      // query: {
                      //     id: 4,
                      //     // gameId: scope.row.game.id
                      // }
                    },
                  );
                });
                maskContainer.addChild(dialog, goovera, goover, onemorea, onemore, selected, unselected, text);
                that.app.stage.addChild(mask, maskContainer);
                // 防止穿透的另一种方法 覆盖层事件覆盖
                mask.on('mouseover', () => {

                });
              };
              // 时间提示
              const addTimeAn = (type: number) => {
                const scorebg = new createjs.Bitmap(App.loader.getResult('scorebg'));
                const five = new createjs.Bitmap(App.loader.getResult('five'));
                const fifteen = new createjs.Bitmap(App.loader.getResult('fifteen'));

                five.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
                fifteen.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
                scorebg.setTransform(769 + scorebg.getBounds().width / 2, 393 + scorebg.getBounds().height / 2, 1, 1, 0, 0, 0, scorebg.getBounds().width / 2, scorebg.getBounds().height / 2);
                if (type == 5) {
                  gameContainer.addChild(scorebg, five);
                } else if (type == 15) {
                  gameContainer.addChild(scorebg, fifteen);
                }
                createjs.Tween.get(scorebg, { loop: true })
                  .to({ rotation: 180 }, 1000, createjs.Ease.easeOut)
                  .call(() => {
                    createjs.Tween.get(fifteen)
                      .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                      .call(() => {
                        gameContainer.removeChild(fifteen);
                      });
                    createjs.Tween.get(five)
                      .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                      .call(() => {
                        gameContainer.removeChild(five);
                      });
                    createjs.Tween.get(scorebg)
                      .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                      .call(() => {
                        gameContainer.removeChild(scorebg);
                      });
                  });
              };
              // addScore
              const addScore = (type: number) => {
                const addbox = new createjs.Container();
                const addtext = new createjs.Text('+ 1', 'bold 100px impact', '#44D7B6');
                const minusbox = new createjs.Container();
                const minustext = new createjs.Text('- 1', 'bold 100px impact', '#F669AB');
                addbox.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
                addbox.addChild(addtext);
                minusbox.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
                minusbox.addChild(minustext);
                if (type == 1) {
                  gameContainer.addChild(addbox);
                  createjs.Tween.get(addbox)
                    .to({ x: 1181, y: 54, alpha: 0.3 }, 1000, createjs.Ease.easeOut)
                    .call(() => {
                      gameContainer.removeChild(addbox);
                    });
                } else if (type == 2) {
                  gameContainer.addChild(minusbox);
                  createjs.Tween.get(minusbox)
                    .to({ x: 1476, y: 54, alpha: 0.3 }, 1000, createjs.Ease.easeOut)
                    .call(() => {
                      gameContainer.removeChild(minusbox);
                    });
                }
              };
              gameContainer.addChild(wordContainer, border, goback, progressContainer, sound, nosound, logo, wrong, score, this.errContainer, this.scoreContainer);
              // 禁止播放按钮
              nosound.alpha = 0;
              gameContainer.alpha = 0;
              // 得分动画

              that.app.stage.addChild(gameContainer, readyContainer);
              // 音量事件

              sound.on('click', (e: any) => {
                that.bgMusic.stop();
                // 更换图片
                nosound.alpha = 1;
              });
              nosound.cursor = 'pointer';
              nosound.on('click', (e: any) => {
                that.bgMusic.play();
                // 更换图片
                nosound.alpha = 0;
              });
              // start
              btn.cursor = 'pointer';
              btn.on('click', (e: any) => {
                initWord(true);
                readyContainer.alpha = 0;
                gameContainer.alpha = 1;
                initCountDownTime(0);
                // 音量键
                nosound.alpha = 0;
                // 播放背景音乐
                that.bgMusic.play();
              });
              // back
              goback.cursor = 'pointer';


              goback.on('click', (e: any) => {
                // mask = this.init_mask();
                that.bgMusic.stop();
                // readyContainer.alpha = 1;
                // gameContainer.alpha = 0;
                that.$router.push({
                  path: '/vocabulary/afterschoolexpand?type=through',
                  // query: {
                  //     id: 4,
                  //     // gameId: scope.row.game.id
                  // }
                });
              });
              // sound
              sound.cursor = 'pointer';

              createjs.Tween.get(btn, { loop: true })
                .to({ scaleX: 1.2, scaleY: 1.2 }, 400, createjs.Ease.linear)
                .to({ scaleX: 0.9, scaleY: 0.9 }, 400, createjs.Ease.linear);


              this.makeResponsive(true, 'both', false, 1, {
                canvas: 'root',
              }, that.app);
              this.startAnimation(that.app.stage);
            }

            protected score(value: number) {
              this.scoreContainer.removeAllChildren();
              const scoreTimes = new createjs.Text(value, '35px impact', '#44D7B6');
              scoreTimes.setTransform(150, 30, 1, 1, 0, 0, 0, 0, 0);
              return scoreTimes;
            }

            protected err(value: number) {
              this.errContainer.removeAllChildren();
              const errTimesMax = new createjs.Text(`${value} / 10`, '35px impact', '#66461F');
              errTimesMax.setTransform(130, 33, 1, 1, 0, 0, 0, 0, 0);
              return errTimesMax;
            }
            // 倒计时
            // protected
            // protected mask() {

        // }
        // protected onAssetsLoaded(loader, resources) {
        //     that.init();
        //     super.onAssetsLoaded();
        // }
      }

      // 实例化
      const game = new CurrentGame(config);
    }

    private async firstLinkGameWord(para: any) {
      return await Game.linkGameWord(para);
    }

    // 词汇连连看
    private async linkGameWord(firstLoad: boolean) {
      // 0-第一次加载，1-非第一次加载 firstLoad
      let para: any;
      if (firstLoad) {
        para = {
          courseId: window.LS.get('vteData').course.courseId,
          firstLoad: 0,
          gameId: 4,
          playModel: 1,
          userId: window.LS.get('basicData').userID,
          sendScore: 1, // 不发送成绩
        };
      } else {
        para = {
          courseId: window.LS.get('vteData').course.courseId,
          firstLoad: 1,
          gameId: 4,
          accuracyNum: this.scoreNumber,
          errorNum: this.errNumber,
          playModel: 0,
          userId: window.LS.get('basicData').userID,
          gameStatisticsId: this.gameStatisticsId,
          sendScore: 0, // 发送成绩
        };
      }

      const res = await Game.linkGameWord(para);
      if (res.data.code == 0) {
        this.setDataLoading(false);
        this.data = res.data.data && res.data.data.wordDetail;
        this.gameStatisticsId = res.data.data.gameStatistics.gameStatisticsId;
        this.residueDegree = res.data.data.residueDegree;
        console.log(this.data);
        // 简单乱序
        if (this.data) {
          this.data.sort(() => (Math.random() > 0.5 ? -1 : 1));
        }
      }
    }

    // 改为时间结束调接口
    private async linkGameWordErr() {
      const para = {
        courseId: window.LS.get('vteData').course.courseId,
        firstLoad: 1,
        gameId: 4,
        accuracyNum: this.scoreNumber,
        errorNum: this.errNumber,
        playModel: 1, // 是否记录排行榜
        userId: window.LS.get('basicData').userID,
        gameStatisticsId: this.gameStatisticsId,
        sendScore: 0, // 结束游戏的时候 发送成绩
      };
      return await Game.linkGameWord(para);
    }
}
